import { useState } from "react";
import "./menuOfferItem.styles.scss";
const MenuOfferItem = ({ menuItem, itemName }) => {
  const [newOffer, setNewOffer] = useState("");
  const [subClass, setSubClass] = useState("moi-subclass-visible");
  const handleHide = () => {
    if (subClass === "moi-subclass-visible") {
      setSubClass("moi-subclass-hidden");
    } else if (subClass === "moi-subclass-hidden") {
      setSubClass("moi-subclass-visible");
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const handleChange = (e) => {
    const { value } = e.target;
    setNewOffer(value);
  };
  if (menuItem["metadata"] === "category") {
    return (
      <div className="menu-offer-category">
        <div className="menu-offer-category-details">
          <span className="moi-category-name">{itemName}</span>
          <span className="moi-category-hide" onClick={handleHide}>
            +
          </span>
        </div>
        <div className={subClass}>
          {Object.keys(menuItem).map((index) => {
            if (index !== "metadata") {
              return (
                <MenuOfferItem menuItem={menuItem[index]} itemName={index} />
              );
            }
          })}
        </div>
      </div>
    );
  } else if (menuItem["metadata"] === "item") {
    return (
      <div className="menu-offer-item">
        <div className="menu-offer-item-details">
          <span className="moi-name">{itemName}</span>
          <span className="moi-price">Current Price : {menuItem["price"]}</span>
          <span className="moi-offer">
            Current Offer : {menuItem["offer"]}
            {menuItem["offer"] !== "" && <span>%</span>}
          </span>
        </div>
        <div className="menu-offer-item-newoffer">
          <form onSubmit={handleSubmit} className="moi-form">
            <input
              type="text"
              name="newOffer"
              className="moi-input"
              value={newOffer}
              onChange={handleChange}
              placeholder="New Offer"
            />
            <button type="submit" className="moi-submit">
              Update
            </button>
          </form>
        </div>
      </div>
    );
  }
};
export default MenuOfferItem;
